import React from "react";
import { Introduction as IntroductionComponent } from "@italymondo/core-ui";
import { formatData } from "./config";
import { useStaticHeroQuery } from "./query";

export function Introduction(): React.ReactElement | null {
  const data = useStaticHeroQuery();

  if (!data) {
    return null;
  }

  const introductionData = formatData(data);

  return <IntroductionComponent {...introductionData} />;
}
